// extracted by mini-css-extract-plugin
module.exports =  {"container":"container_fIWkB_My","title":"title_mXvwmr_k"};